import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=1a0ad9a6&scoped=true"
import script from "./TaskDetail.vue?vue&type=script&lang=ts"
export * from "./TaskDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0ad9a6",
  null
  
)

export default component.exports